const DARK_THEMES = ['dark', 'high-contrast-dark'];

/**
 * Whether a reader theme uses a dark base palette.
 * @param {string} theme - Reader theme name (e.g. 'sepia', 'high-contrast-dark')
 * @returns {boolean}
 */
export default function isDarkTheme(theme) {
    return DARK_THEMES.includes(theme);
}
